import { render, staticRenderFns } from "./currencyRate.vue?vue&type=template&id=6ad22ac3"
import script from "./currencyRate.vue?vue&type=script&lang=js"
export * from "./currencyRate.vue?vue&type=script&lang=js"
import style0 from "./currencyRate.vue?vue&type=style&index=0&id=6ad22ac3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports